import { useEffect, useRef } from 'react';
import { LottieRefCurrentProps } from 'lottie-react';

import { useSteps } from 'src/hooks';
import { StepsEnum } from 'src/types';

const TIMEOUT_DURATION = 20000;

export const useLookAtPlayWallStep = () => {
  const { activeStep, nextStep } = useSteps();
  const isActiveStep = activeStep === StepsEnum.LOOK_AT_PLAY_WALL;
  const lottieRef = useRef<LottieRefCurrentProps | null>(null);

  useEffect(() => {
    if (!isActiveStep) return;
    const timeout = setTimeout(() => {
      nextStep();
    }, TIMEOUT_DURATION);
    return () => clearTimeout(timeout);
  }, [nextStep, isActiveStep, activeStep]);

  useEffect(() => {
    lottieRef.current?.stop();
    if (!isActiveStep) return;
    const timeout = setTimeout(() => {
      lottieRef.current?.play();
    }, 1000);
    return () => clearTimeout(timeout);
  }, [isActiveStep]);

  return {
    lottieRef,
  };
};
